// extracted by mini-css-extract-plugin
export default {"Body":"_Jnsw_WhV7GNvn9d_93U","Filters":"TUiJiQosNXoLWspPKSFb","Results":"HluPe9sFsibQLDBItEDi","SearchBox":"Y4lOimJi7ybZxle59qi8"};